// extracted by mini-css-extract-plugin
export default {"container":"gMnc0y","headerContainer":"mOqzdf","commentCount":"T6nYAV","text":"VDTY4G","buttonContainer":"kf1i3F","errorCode":"cXGjd3"};